import NotFoundPage from 'pages/404Page';
import { useEffect } from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import privateRoutes, { privateRouteWithoutLayout } from './PrivateRoutes';
import publicRoutes from './PublicRoutes';

const Routes = () => {
  useEffect(() => {
    const ele = document.getElementById('ipl-progress-indicator');
    if (ele) {
      setTimeout(() => {
        // fade out
        ele.classList.add('available');
      }, 500);
      setTimeout(() => {
        // remove from DOM
        ele.outerHTML = '';
      }, 1500);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <BrowserRouter>
        <Switch>
          {publicRoutes()}
          {privateRouteWithoutLayout()}
          {privateRoutes()}
          <NotFoundPage />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default Routes;
